import React from 'react';

/** Split CMS textarea content into paragraph elements. */
export const renderCmsParagraphs = (text) => {
  if (!text?.trim()) return null;
  return text
    .split(/\n\n+/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean)
    .map((paragraph, index) => <p key={index}>{paragraph}</p>);
};
